import { authRoles } from 'app/auth';
import SensorTypeTable from './table/SensorTypeTable';
import SensorTypeEditForm from './editform/SensorTypeEditForm';

export default [
	{
		path: '/sensor-type/edit/:id',
		component: SensorTypeEditForm,
		auth: authRoles.sensorType
	},
	{
		path: '/sensor-type/:sessionNameParam?',
		component: SensorTypeTable,
		auth: authRoles.sensorType
	}
];
